import { render, staticRenderFns } from "./ShipmentItems.vue?vue&type=template&id=2fb48535&"
import script from "./ShipmentItems.vue?vue&type=script&lang=js&"
export * from "./ShipmentItems.vue?vue&type=script&lang=js&"
import style0 from "./ShipmentItems.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports